module.exports = __webpack_public_path__ + "img/jeton-logo.2d9615b4.svg";